import React from 'react';
import {dateFromDateString, hourMinutesFromDateString,} from '../../libs/utils';
import './style.scss';
import {getCountryCode} from '../../libs/utils';

const TEXTS = {
    IN_STORE: (vars) => {
        return `Your order from ${vars.retailer.name} is confirmed. We’ll share your delivery time window on the day of the delivery. Add your delivery preferences and instructions to make delivery smoother`;
    },

    ASSIGNED: (vars) => {
        return `We have assigned ${vars.traveller && vars.traveller.firstName ? vars.traveller.firstName : 'Flyper'} to deliver your order from ${vars.retailer.name}`;
    },

    PICKED_UP: (vars) => {
        return `${vars.traveller && vars.traveller.firstName ? vars.traveller.firstName : 'Flyper'} has picked up your order from ${vars.retailer.name}. Your order is out for delivery`;
    },

    FAILED: (vars) => {
        return `${vars.traveller && vars.traveller.firstName ? vars.traveller.firstName : 'Flyper'} attempted to deliver your order but couldn’t reach you. Your delivery will be rescheduled`;
    },

    DELIVERING: (vars) => {
         return `Delivery is taking place please confirm by providing the code and accepting the delivery`;
    },

    DELIVERED: (vars) => {
        return `Your order from ${vars.retailer.name} has arrived! Don't forget to give ${vars.traveller.firstName} a rating :)`;
    },

    REVIEWED: (vars) => {
        return `Your feedback helps us improve our service, thank you!`;
    },

    booked: (vars) => {
        return `Your order from ${vars.retailer.name} is confirmed. We’ll share your delivery time window on the day of the delivery. Add your delivery preferences and instructions to make delivery smoother`;
    },

    to_delivery: (vars) => {
        return `${vars.traveller && vars.traveller.firstName ? vars.traveller.firstName : 'Flyper'} has picked up your order from ${vars.retailer.name}. Your order is out for delivery`;
    },

    delivery_attempt_failed: (vars) => {
        return `${vars.traveller && vars.traveller.firstName ? vars.traveller.firstName : 'Flyper'} attempted to deliver your order but couldn’t reach you. A new delivery attempt will be scheduled, and you’ll receive an update once confirmed`;
    },

    delivery_reattempt: (vars) => {
        return `Your order from ${vars.retailer.name} is now set for a new delivery time. Please add delivery preferences and instructions to help ensure a successful delivery`;
    },

    undeliverable: (vars) => {
        return `Your order from ${vars.retailer.name} was deemed undeliverable and has now been canceled. Please contact ${vars.retailer.name} directly for further assistance`;
    },

    cancelled: (vars) => {
        return `Your order from ${vars.retailer.name} has been canceled. Please contact us if you have any questions`;
    },

    delayed: (vars) => {
        return `Your order from ${vars.retailer.name} has been delayed. A new delivery date will be scheduled soon. We apologize for the inconvenience!`;
    },

    delivered: (vars) => {
        return `Your order from ${vars.retailer.name} has arrived! Don't forget to give ${vars.traveller.firstName} a rating :)`;
    },

    DEFAULT: null,
};

const StatusCard = ({ data, id, delivery, traveller }) => {
    if (!TEXTS[data.status]) {
        return null;
    }
    return (
        <div className="Feed-card">
            <div className="Feed-card__header">
                <div>
                    <span className="Icon Icon-flype" />
                    <span className="spaced-left-12">Flype</span>
                </div>
                <div>
                    {dateFromDateString(data.moment)},{' '}
                    {hourMinutesFromDateString(data.moment)}
                </div>
            </div>
            <div className="Feed-card__main">
                {TEXTS[data.status]({
                    ...data,
                    ...delivery,
                    country: getCountryCode(),
                    ...{ traveller: traveller || { firstName: '' } },
                })}
                {data.picture ? (
                    <a href={data.picture} target={'_picture'}>
                        <img
                            style={{
                                float: 'right',
                                borderRadius: 10,
                                marginTop: 8,
                                width: 53,
                                height: 53,
                            }}
                            alt={'Delivery dropped outside the door'}
                            src={data.picture}
                        />
                    </a>
                ) : null}
                { data?.status === 'delivered' && data?.dropOffMethod && data?.dropOffMethod !== 'Other' ? (
                    <div className='delivery-details'>
                        Delivery details: {data.dropOffMethod}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

const getCardList = (items, delivery, traveller) => {
    if (!items || !delivery) {
        return null;
    }

    return items
        .map((item, idx) => {
            return (
                <StatusCard
                    key={idx}
                    id={idx}
                    data={item}
                    delivery={delivery}
                    traveller={traveller}
                />
            );
        })
        .reverse();
};

const StatusCards = ({ data, backupData, delivery, traveller }) => {
    let dataToDisplay = data ? data : backupData;
    return (
        <section className="Section bg-gradient-blue Grid Grid--centered">
            <div className="Grid__column">
                <div className="spacer-32"></div>
                <h2 className="text-title-1 ">Delivery events</h2>

                <div className="spacer-16"></div>

                <div className="">{getCardList(dataToDisplay, delivery, traveller)}</div>

                <div className="spacer-16"></div>
            </div>
        </section>
    );
};

export { StatusCards };
